import React, {useEffect, useState} from 'react';
import {Box, Button, AppBar, Toolbar, Typography, Modal, TextField, LinearProgress} from '@mui/material';
import {Add, CloudUpload, Delete, Image} from '@mui/icons-material';
import HeaderAvatar from "../components/HeaderAvatar";
import {Product} from '../services/types'
import {fetchProducts, addProduct, updateProduct, deleteProduct, uploadPhoto} from "../services/api";
import Icon from "../components/Icon";

interface UploadAreaProps {
    onUpload: (file: File) => void;
}
const Products: React.FC = () => {
    // const { permissions } = usePermissions();
    const [loading, setLoading] = useState(true);
    const [products, setProducts] = useState<Product[]>([]);
    const [page, setPage] = useState(1);
    const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
    const [isEditModalOpen, setIsEditModalOpen] = useState(false);
    const [hasMore, setHasMore] = useState(true);
    const [currentProduct, setCurrentProduct] = useState<Product | null>(null);
    const [createName, setCreateName] = useState('');
    const [error, setError] = useState<string | null>(null);
    const [isDeleteConfirmOpen, setIsDeleteConfirmOpen] = useState(false);
    const [uploadProgress, setUploadProgress] = useState(0);
    const [isUploadModalOpen, setIsUploadModalOpen] = useState(false);

    const fetchProductsData = async () => {
        try {
            setLoading(true);
            const data = await fetchProducts(page);
            setProducts(data.items);
            setHasMore(data.items.length === 100);
        } catch (error) {
            console.error('Error fetching products:', error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchProductsData();
    }, []);

    const handleCreate = async () => {
        try {
            const addData = {
                title: createName,
                description: "",
                pictureId: 1
            }
            await addProduct(addData);
            setIsCreateModalOpen(false);
            setCreateName('');
            fetchProductsData();
        } catch (error) {
            console.error('Error inviting team member:', error);
            setError('Failed to send invitation');
        }
    };

    const handleUpdate = async () => {
        try {
            const updateData = {
                title: currentProduct?.title,
                description: currentProduct?.description,
                pictureId: currentProduct?.picture.id!!
            }
            await updateProduct(currentProduct?.id, updateData);
            setIsEditModalOpen(false);
            fetchProductsData();
        } catch (error) {
            console.error('Error inviting team member:', error);
            setError('Failed to send invitation');
        }
    };

    const handleDelete = async () => {
        try {
            await deleteProduct(currentProduct?.id);
            setIsEditModalOpen(false);
            fetchProductsData();
        } catch (error) {
            console.error('Error inviting team member:', error);
            setError('Failed to send invitation');
        }
    };

    const handleEdit = async (product: Product) => {
        setCurrentProduct(product)
        setIsEditModalOpen(true)
    };
    const handleDeleteRequest = () => {
        setIsDeleteConfirmOpen(true);
    };
    const handleDeleteConfirm = async () => {
        try {
            await deleteProduct(currentProduct?.id);
            setIsEditModalOpen(false);
            setIsDeleteConfirmOpen(false);
            fetchProductsData();
        } catch (error) {
            console.error('Error deleting product:', error);
            setError('Failed to delete product');
        }
    };

    const formatFileSize = (bytes: number) => {
        if (bytes === 0) return '0 Байт';

        const k = 1024;
        const sizes = ['Байт', 'КБ', 'МБ', 'ГБ', 'ТБ'];
        const i = Math.floor(Math.log(bytes) / Math.log(k));

        return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
    };

    const handleDrop = (e: React.DragEvent<HTMLDivElement>) => {
        e.preventDefault();
        const file = e.dataTransfer.files[0];
        if (file) {
            handleUpload(file);
        }
    };
    const handleFileSelect = (e: React.ChangeEvent<HTMLInputElement>) => {
        const file = e.target.files?.[0];
        if (file) {
            handleUpload(file);
        }
    };
    const UploadArea: React.FC<UploadAreaProps> = ({ onUpload }) => (
        <Box
            sx={{
                border: '1px dashed grey',
                borderRadius: 1,
                p: 0,
                mt: 2,
                mb: 3,
                textAlign: 'center',
                cursor: 'pointer',
                overflow: 'hidden'
            }}
            onClick={() => document.getElementById('photo-upload')?.click()}
            onDrop={handleDrop}
            onDragOver={(e) => e.preventDefault()}
        >
            {
                currentProduct?.picture.id !== 1 ?
                    <img src={'https://stage.selfdetailing.ru'+currentProduct?.picture.raw} alt={currentProduct?.picture.raw} style={{maxHeight: '300px', objectFit:'contain', width:'390px'}}/>
                :
                    <Typography sx={{lineHeight: '80px'}}>Нажмите или перетащите фото</Typography>
            }
            <input
                id="photo-upload"
                type="file"
                style={{ display: 'none' }}
                onChange={handleFileSelect}
            />
        </Box>
    );


    const handleUpload = async (file: File) => {
        setIsUploadModalOpen(true);
        try {
            const response = await uploadPhoto(file, (progress) => {
                setUploadProgress(progress);
            });
            if (currentProduct != null){
                setCurrentProduct({
                    ...currentProduct,
                    picture: response
                });
            }
            // fetchFoldersAndVideos(currentPage, currentFolder?.id || null);
        } catch (error) {
            console.error('Error uploading video:', error);
        } finally {
            setIsUploadModalOpen(false);
            setUploadProgress(0);
        }
    };

    return (
        <Box>
            <AppBar className={loading ? 'headerBlock preloading' : 'headerBlock'} position="static">
                <Toolbar className='toolbar'>
                    <Box className='toolbarTitle'>Продукты <span>{products.length}</span></Box>
                    <Button className="addToobarBtn" variant="contained" onClick={() => {}}><Add /></Button>
                    <HeaderAvatar/>
                </Toolbar>
            </AppBar>

                <Box>
                    <Box className='topButtonsContainer hideMPageButtons'>
                        <Box></Box>
                        <Button className='topButtonsAdd' variant="outlined" onClick={() => setIsCreateModalOpen(true)}><Add /> Добавить продукт</Button>
                    </Box>
                    {!loading && (

                        <Box className='productItems'>
                            {products.map((product) => (
                                <Box className='productItem' key={product.id} onClick={() => handleEdit(product)}>
                                    {product.picture.id !== 1 && (
                                        <Box>
                                            <img src={'https://stage.selfdetailing.ru'+product?.picture.raw} alt={product?.picture.raw!!}/>
                                        </Box>
                                        )}
                                    <Box className='productItemText'>
                                        {product.title}
                                    </Box>
                                </Box>
                            ))}
                        </Box>
                    )}
                </Box>


            {/* Модальное окно добавления */}
            <Modal open={isCreateModalOpen} onClose={() => setIsCreateModalOpen(false)}>
                <Box sx={{flexGrow:1, minHeight: '100vh', display: 'flex', justifyContent:'center', alignItems:'center'}}>
                    <Box className="modalFiled" sx={{ position: 'relative', bgcolor: 'background.paper', boxShadow: 24, maxWidth: 600 }}>
                        <Typography variant="h6">Создание продукта</Typography>
                        <TextField
                            label="Название"
                            value={createName}
                            onChange={(e) => setCreateName(e.target.value)}
                            fullWidth
                            type="text"
                            margin="normal"
                        />
                        <Box sx={{display:'flex', justifyContent: 'space-between', mt: 2, gap: 2}}>
                            <Button className="blueModalButton" variant="contained" onClick={handleCreate}>
                                Создать
                            </Button>
                            <Button className="blueModalButton" variant="outlined" onClick={()=>setIsCreateModalOpen(false)} style={{color: 'red', borderColor: 'red'}}>
                                Отмена
                            </Button>
                        </Box>
                    </Box>
                </Box>
            </Modal>

            {/* Модальное окно редактирования */}
            <Modal open={isEditModalOpen} onClose={() => setIsEditModalOpen(false)}>
                <Box sx={{flexGrow:1, minHeight: '100vh', display: 'flex', justifyContent:'center', alignItems:'center'}}>
                    <Box className="modalFiled" sx={{ position: 'relative', bgcolor: 'background.paper', boxShadow: 24, maxWidth: 600 }}>
                        <Typography variant="h6">Редатирование продукта</Typography>
                        <TextField
                            label="Название"
                            value={currentProduct?.title || ''}
                            onChange={(e) => {
                                if (currentProduct) {
                                    setCurrentProduct({
                                        ...currentProduct,
                                        title: e.target.value
                                    });
                                }
                            }}
                            fullWidth
                            type="text"
                            margin="normal"
                        />
                        <TextField
                            label="Описание"
                            value={currentProduct?.description || ''}
                            onChange={(e) => {
                                if (currentProduct) {
                                    setCurrentProduct({
                                        ...currentProduct,
                                        description: e.target.value
                                    });
                                }
                            }}
                            fullWidth
                            type="text"
                            margin="normal"
                        />
                        <UploadArea onUpload={handleUpload} />
                        <Box sx={{display:'flex', justifyContent: 'space-between', mt: 2, gap: 2}}>
                            <Button className="blueModalButton" variant="contained" onClick={handleUpdate}>
                                Сохранить
                            </Button>
                            <Button className="blueModalButton" variant="outlined" onClick={()=>setIsEditModalOpen(false)} style={{color: 'red', borderColor: 'red'}}>
                                Отмена
                            </Button>
                            <Button
                                className="addToobarBtn"
                                variant="contained"
                                onClick={handleDeleteRequest}
                            >
                                <Icon name="remove" />
                            </Button>

                        </Box>
                    </Box>
                </Box>
            </Modal>

            <Modal open={isDeleteConfirmOpen} onClose={() => setIsDeleteConfirmOpen(false)}>
                <Box sx={{flexGrow:1, minHeight: '100vh', display: 'flex', justifyContent:'center', alignItems:'center'}}>
                    <Box className="modalFiled" sx={{ position: 'relative', bgcolor: 'background.paper', boxShadow: 24, maxWidth: 400, p: 3 }}>
                        <Typography variant="h6" sx={{mb: 2}}>
                            Вы действительно хотите удалить продукт {currentProduct?.title}?
                        </Typography>
                        <Box sx={{display:'flex', justifyContent: 'flex-end', gap: 2}}>
                            <Button variant="contained" color="error" onClick={handleDeleteConfirm}>Удалить</Button>
                            <Button variant="outlined" onClick={() => setIsDeleteConfirmOpen(false)}>Отмена</Button>
                        </Box>
                    </Box>
                </Box>
            </Modal>

            {/* Модальные окна */}
            <Modal open={isUploadModalOpen} onClose={() => setIsUploadModalOpen(false)}>
                <Box sx={{flexGrow:1, minHeight: '100vh', display: 'flex', justifyContent:'center', alignItems:'center'}}>
                    <Box className="modalFiled" sx={{ position: 'relative', bgcolor: 'background.paper', boxShadow: 24, maxWidth: 600 }}>
                        <Box sx={{ /* стили */ }}>
                            <Typography sx={{mb: 3}}>Пожалуйста, дождитесь завершения загрузки</Typography>
                            <LinearProgress variant="determinate" value={uploadProgress} />
                            <Typography>{uploadProgress}%</Typography>
                        </Box>
                    </Box>
                </Box>
            </Modal>
        </Box>
    );
};

export default Products;
